import { render, staticRenderFns } from "./DeleteComponentManageButton.vue?vue&type=template&id=5421fe10&scoped=true&"
import script from "./DeleteComponentManageButton.vue?vue&type=script&lang=js&"
export * from "./DeleteComponentManageButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5421fe10",
  null
  
)

export default component.exports